var render = function render(_c,_vm){return _c('hr',{class:[_vm.data.class, _vm.data.staticClass, 'sf-divider'],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"data-cy":"divider"}})
}
var staticRenderFns = []

export { render, staticRenderFns }